/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BaseMedicalHistoryFormComponent from "core/components/medical-history/abstract/base-edition-form";
import { validatePresence } from "ember-changeset-validations/validators";
import { ValidatorMap } from "ember-changeset/types";
import MedicalHistoryBaseEditionForm from "../base-edition-form";
export default class MentalwiseMedicalHistoryEditionForm extends BaseMedicalHistoryFormComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "MedicalHistoryBaseEditionForm", MedicalHistoryBaseEditionForm);
    _defineProperty(this, "retrieveJournalEvent", () => this.args.patient.medicalHistoryChangedJournalEvent);
    _defineProperty(this, "depressionPathologyProperties", ["numberOfTs", "suicideRisk", "suicidalThoughtsStartDate"]);
    _defineProperty(this, "journalEventProperties", ["mainDiagnosis", ...this.sharedProperties, ...this.depressionPathologyProperties]);
  }
  get patho() {
    return this.args.patient.followUpReasonRecord?.patho;
  }
  get validations() {
    const validations = {
      mainDiagnosis: validatePresence({
        presence: true,
        description: "Le diagnostic principal"
      })
    };
    if (this.patho === "depression") validations["suicideRisk"] = validatePresence({
      presence: true,
      description: "Le risque suicidaire"
    });
    return validations;
  }
}
_defineProperty(MentalwiseMedicalHistoryEditionForm, "fullComponentId", "medical-history/edition");